module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "toggle-switch",
    style: (_vm.switchStyle)
  }, _vm._l((_vm.defaultOptions.items.labels), function(label, index) {
    return _c('li', {
      key: index,
      style: (_vm.itemStyle)
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.defaultItem),
        expression: "defaultItem"
      }],
      attrs: {
        "disabled": _vm.defaultOptions.items.disabled,
        "id": label.name,
        "name": _vm.defaultItem,
        "type": "radio"
      },
      domProps: {
        "value": label.name,
        "checked": _vm._q(_vm.defaultItem, label.name)
      },
      on: {
        "change": [function($event) {
          _vm.defaultItem = label.name
        }, function($event) {
          $event.stopPropagation();
          _vm.toggle($event)
        }]
      }
    }), _vm._v(" "), (label.name === _vm.selectedItem) ? _c('label', {
      class: {
        active: !_vm.defaultOptions.items.disabled
      },
      style: (_vm.labelStyleSelected(label.color, label.backgroundColor)),
      attrs: {
        "for": label.name,
        "type": "radio"
      }
    }, [_vm._v(_vm._s(label.name))]) : _c('label', {
      class: {
        active: !_vm.defaultOptions.items.disabled
      },
      style: (_vm.labelStyle),
      attrs: {
        "for": label.name,
        "type": "radio"
      }
    }, [_vm._v(_vm._s(label.name))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46bfeb61"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ToggleSwitch.vue
// module id = 7
// module chunks = 0